import { render, staticRenderFns } from "./form-select.vue?vue&type=template&id=3124c29a&scoped=true&"
import script from "./form-select.vue?vue&type=script&lang=js&"
export * from "./form-select.vue?vue&type=script&lang=js&"
import style0 from "./form-select.vue?vue&type=style&index=0&id=3124c29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3124c29a",
  null
  
)

export default component.exports